// extracted by mini-css-extract-plugin
export default {"info":"_19rGI2z_XfHC6e5f93m6V5"};